// import { Box } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

import Routes from "src/Routes";

const App: FunctionComponent = () => {
  document.addEventListener("contextmenu", (event) => event.preventDefault());

  return (
    <>
      {/* <Box
        id="google_translate_element"
        zIndex={90}
        position={"fixed"}
        right={300}
        top={7}
      /> */}
      <Routes />
      <Outlet />
    </>
  );
};

export default App;
